var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExclamationMark = function SvgExclamationMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#exclamation_mark_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.293.544 8.163 8.163c.725.725.725 1.86 0 2.585l-8.163 8.163c-.727.727-1.905.727-2.586 0L.544 11.292a1.81 1.81 0 0 1 0-2.585L8.707.544a1.81 1.81 0 0 1 2.586 0m-1.27 12.38c-.181 0-.317.047-.453.092a1 1 0 0 0-.363.227c-.091.09-.182.181-.227.317a1.3 1.3 0 0 0-.091.408c0 .181.046.272.09.408.047.136.137.227.228.317.136.091.227.182.363.228.136.045.272.09.453.09s.317-.045.453-.09a1 1 0 0 0 .363-.228c.091-.09.182-.18.227-.317.046-.136.091-.272.091-.408s-.046-.272-.09-.408c-.047-.136-.137-.226-.228-.317a1 1 0 0 0-.363-.227 1.3 1.3 0 0 0-.453-.091zm.997-7.89H8.934l.227 6.848h1.632z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "exclamation_mark_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export { SvgExclamationMark as ReactComponent };
export default "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJzdGF0aWMvbWVkaWEvZXhjbGFtYXRpb25fbWFyay4wNTYyOGUxMC5zdmciOw==";